import React, { useRef, useEffect, useState } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { gsap } from 'gsap';
import { Draggable, InertiaPlugin } from 'gsap/all';

gsap.registerPlugin(Draggable, InertiaPlugin);

const GalleryBlock = ({ gallery }) => {
  const carouselRef = useRef(null);
  const [itemWidth, setItemWidth] = useState(0);

  useEffect(() => {
    const scroller = carouselRef.current;
    const width = scroller.firstElementChild?.clientWidth || 0;

    setItemWidth(width);

    const draggableInstance = Draggable.create(scroller, {
      type: 'scrollLeft',
      edgeResistance: 0.5,
      bounds: scroller,
      inertia: true,
      throwProps: true,
      onPress: () => scroller.classList.add('is-dragging'),
      onRelease: () => scroller.classList.remove('is-dragging'),
    });

    return () => {
      draggableInstance[0].kill();
    };
  }, [itemWidth]);

  return (
    <section className="gallery-block">
      <div className="gallery-block__inner" ref={carouselRef} style={{ overflowX: 'auto' }}>
        {gallery?.map((image, i) => (
          <GatsbyImage image={getImage(image.localFile)} alt={image.altText} key={i} />
        ))}
      </div>
    </section>
  );
};

GalleryBlock.defaultProps = {
  gallery: [],
};

export default GalleryBlock;